<template>
  <div @click="triggerAppOpen" :class="['viewar', {default: attributes.default, issupporeted: isARSupporeted, isdesktop: !isMobile}]">
    <img src="~/images/project/icon-ar.svg" >
    <div v-if="isMobile" class="text">
      <p v-if="isARSupporeted" class="ar-btn">
        View in augmented reality
      </p>
      <p v-else class="mobile-no-support">
        Augmented reality (AR) is not supported on this device. To view, ensure that you have iOS 12+ or Android 9+.
      </p>
    </div>
    <div v-else class="text">
      <div class="divider"></div>
      <p>
        <!-- <strong>Download</strong> the ST App on your mobile.
        Explore this interactive graphic on mobile to view AR. -->
        Explore this interactive in augmented reality (AR) on your phone. This feature requires the ST app.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['attributes'],
  data () {
    return {
    }
  },
  computed: {
    isAndroid () {
      return (/(android)/i.test(window.navigator.userAgent))
    },
    isMobile () {
      return window.browserInfo.mobile
      // return (/Android|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera)
    },
    isIpad () {
      return (/iPad/i).test(navigator.userAgent || navigator.vendor || window.opera)
    },
    isARSupporeted () {
      if (window.browserInfo.os.toLowerCase() === 'ios' && parseFloat(window.browserInfo.osVersion) >= 12.0) {
        return true
      } else if (window.browserInfo.os.toLowerCase() === 'android' && parseFloat(window.browserInfo.osVersion) >= 9.0) {
        return true
      }
      return false
    }
  },
  methods: {
    fallbackToAppStore () {
      let schemeStr = 'https://apps.apple.com/sg/app/the-straits-times-for-iphone/id547465441?mt=8' // Apple
      if (this.isAndroid) {
        schemeStr = 'https://play.google.com/store/apps/details?id=com.buuuk.st&hl=en'
      }
      return schemeStr
    },
    openApp () {
      // const assetRootFolder = process.env.NODE_ENV === 'production'
      // ? 'https://www.straitstimes.com/multimedia/graphics/assets/ar-assets'
      // : 'https://st-graphics-dev-assets.s3-ap-southeast-1.amazonaws.com/ar-assets'

      let schemeStr = this.attributes.ioslink

      if (this.isAndroid) {
        schemeStr = this.attributes.androidlink
      }

      if (!schemeStr) return

      schemeStr = schemeStr + `&browser=${window.browserInfo.browser}`

      if (!this.inSTApp()) {
        schemeStr = schemeStr + `&referer=${window.location.href}`
        this.$confirm(
          {
            xclose: true,
            message: `Get the full AR experience with the ST app.`,
            button: {
              no: 'Get app',
              yes: 'Yes, I have the app'
            },
            callback: confirm => {
              if (confirm) {
                window.location = schemeStr
              } else if (confirm !== null) {
                window.location = this.fallbackToAppStore()
              }
            }
          }
        )
      } else {
        try {
          window.location = schemeStr
        } catch (err) {
          window.location = this.fallbackToAppStore()
        }
      }
    },
    triggerAppOpen () {
      if (this.isMobile) {
        if (!this.isARSupporeted) {
          console.log('Not Supported')
          return false
        }
        this.openApp()
        return true
      }
      window.location = this.fallbackToAppStore()
    },
    inSTApp () {
      if (!(/com.sph.stiphone|com.buuuk.st/i).test(navigator.userAgent.toLowerCase())) {
        const params = (new URL(document.location)).searchParams
        let client = params.get('st_client') || params.get('client')
        if (client === 'in-app-webview') {
          return true
        }
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.viewar {
  position: relative;
  cursor: pointer;
  /* display: inline-block; */
  width: 100%;
  max-width: 80vw;
  border: 1px solid rgb(255 242 0 / 100%) !important;
  border-radius: 25px;
  text-align: center;
  padding: 10px 23px;
  background: rgb(151 161 168 / 0.85);
  left: 50%;
  transform: translateX(-50%);
  &.issupporeted {
    position: unset;
    left: unset;
    transform: unset;
    display: inline;
  }
  img {
    vertical-align: middle;
    width: 25px;
  }
  .divider {
    width: 100px;
    border-bottom: 1px solid rgb(190 198 204);
    margin: 8px auto 5px;
  }
  .text {
    display: inline-block;
    padding-left: 10px;
  }
  p {
    text-align: left;
    font-family: $font-CuratorRegular;
    font-size: 14px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.6);
    width: 100%;
    padding-top: 5px;
  }
  strong {
    font-family: $font-CuratorBold;
    font-weight: normal;
  }
  &.default {
    p {
      color: rgba(38, 59, 71, 0.6);
    }
  }
}
.viewar.isdesktop {
  width: 315px !important;
  border-radius: 10px;
  background: transparent;
  .text {
    display: block;
  }
}
</style>
